import { useAtom } from 'jotai'
import { useTranslation } from 'react-i18next'
import ExplorerLink from 'src/common/components/Link/ExplorerLink'
import useAuthorizations from 'src/common/queries/useAuthorizations/useAuthorizations'
import { authorizationsToQualifyAtom } from 'src/common/stores/store'
import Modal from 'src/common/ui-kit/Modal'
import Skeleton from 'src/common/ui-kit/Skeleton/Skeleton'

const GetQualifiedModal = () => {
  const { t } = useTranslation('common')
  const [authorizationsToQualify, setAuthorizationsToQualify] = useAtom(
    authorizationsToQualifyAtom
  )
  const { filterAuthorizationsByAddresses, isLoading } = useAuthorizations([], {
    enabled: !!authorizationsToQualify && authorizationsToQualify.length > 0,
  })

  const filteredAuthorizations = filterAuthorizationsByAddresses(
    authorizationsToQualify || []
  )?.filter(auth => !auth.isFullyAuthorized)

  const handleGetQualified = (link: string) => {
    window.open(link, '_blank')
  }

  return (
    <Modal
      open={!!authorizationsToQualify}
      onClose={() => setAuthorizationsToQualify(null)}
      className='py-5 px-5'
    >
      <div className='flex flex-col'>
        <h3 className='typo-title2 sm:typo-title3 font-medium text-main-accent mb-2 text-center'>
          {t('authorizations.title')}
        </h3>
        <span className='text-body2 font-medium text-main-muted mb-2'>
          {t('authorizations.description')}
        </span>
        <span className='text-label2 font-medium mb-2'>
          {t(`authorizations.qualifier`)}
        </span>
        {isLoading ? (
          <div>
            <div className='flex flex-col justify-center items-center space-y-2.5'>
              <Skeleton height={21} count={3} />
            </div>
          </div>
        ) : (
          <ul className='space-y-2.5'>
            {filteredAuthorizations?.map((auth, index) => (
              <li
                key={index}
                className='flex justify-between items-center typo-label2'
              >
                <div className='flex gap-1.5 items-center'>
                  <ExplorerLink
                    className='group hover:text-primary font-medium'
                    iconClassName='group-hover:fill-primary fill-main-accent'
                    {...(auth.name && { label: auth.name })}
                    hash={auth.authContractAddress}
                    type={'address'}
                  />
                </div>
                <div>
                  {auth.linkToQualify ? (
                    <span
                      className='text-label2 font-medium hover:text-primary transition-colors cursor-pointer'
                      onClick={() => handleGetQualified(auth.linkToQualify)}
                    >
                      {t('buttonCaptions.getQualified')}
                    </span>
                  ) : (
                    <span className='text-label2 font-medium'>
                      {t('authorizations.noLink')}
                    </span>
                  )}
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </Modal>
  )
}

export default GetQualifiedModal
